export var BusinessLimitField;
(function (BusinessLimitField) {
    BusinessLimitField["FromCurrency"] = "FROM_CURRENCY";
    BusinessLimitField["ToCurrency"] = "TO_CURRENCY";
    BusinessLimitField["FromCountry"] = "FROM_COUNTRY";
    BusinessLimitField["ToCountry"] = "TO_COUNTRY";
    BusinessLimitField["FromChannel"] = "FROM_CHANNEL";
    BusinessLimitField["ToChannel"] = "TO_CHANNEL";
    BusinessLimitField["FromProcessor"] = "FROM_PROCESSOR";
    BusinessLimitField["ToProcessor"] = "TO_PROCESSOR";
    BusinessLimitField["Business"] = "BUSINESS";
    BusinessLimitField["TransactionCount"] = "TRANSACTION_COUNT";
    BusinessLimitField["TransactionVolume"] = "TRANSACTION_VOLUME";
    BusinessLimitField["TransactionType"] = "TRANSACTION_TYPE";
    BusinessLimitField["TransactionAmount"] = "TRANSACTION_AMOUNT";
    BusinessLimitField["WalletTag"] = "WALLET_TAG";
})(BusinessLimitField || (BusinessLimitField = {}));
export var BusinessLimitFrequency;
(function (BusinessLimitFrequency) {
    BusinessLimitFrequency["Once"] = "ONCE";
    BusinessLimitFrequency["Daily"] = "DAILY";
    BusinessLimitFrequency["Weekly"] = "WEEKLY";
    BusinessLimitFrequency["Monthly"] = "MONTHLY";
})(BusinessLimitFrequency || (BusinessLimitFrequency = {}));
//# sourceMappingURL=BusinessLimit.js.map